// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselService\LloydServiceSearchResponse.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { LloydServiceVessel, LloydServiceVesselData, LloydServiceVesselOptions } from 'data/models/LloydServiceVessel';

// LloydServiceSearchData is the class that LloydServiceSearch serializes to/from
export interface LloydServiceSearchData {
    CallSign : string | null;
    IMO : number | null;
    MMSID : number | null;
	
    Results : LloydServiceVesselData[] | null;
	
}

// LloydServiceSearchOptions is the class which may be passed to the LloydServiceSearch constructor to define optional initial data values
export interface LloydServiceSearchOptions {
    CallSign : string | null;
    IMO : number | null;
    MMSID : number | null;
	
    Results? : LloydServiceVesselOptions[] | null;
	
}

export class LloydServiceSearch {
    public CallSign : DataSignal<string | null>;
    public IMO : DataSignal<number | null>;
    public MMSID : DataSignal<number | null>;
	
    public Results : SDataArray<LloydServiceVessel>;
	

    constructor();
    constructor(data : LloydServiceSearchOptions);
    constructor(data: LloydServiceSearchOptions | null = null) {
        this.CallSign = jsonableObservable(S.value<string | null>(data && data.CallSign !== undefined ? data.CallSign : null));
        this.IMO = jsonableObservable(S.value<number | null>(data && data.IMO !== undefined ? data.IMO : null));
        this.MMSID = jsonableObservable(S.value<number | null>(data && data.MMSID !== undefined ? data.MMSID : null));
	    
        this.Results = SArray<LloydServiceVessel>([]);
	    
    }

    static key(obj : LloydServiceSearch) {
        return (obj.CallSign() === null ? '\u2603' : obj.CallSign()!) + '\u2618' + (obj.IMO() === null ? NaN : obj.IMO()!) + '\u2618' + (obj.MMSID() === null ? NaN : obj.MMSID()!);
    }
    
    static dataKey(obj : LloydServiceSearchOptions) {
        return (obj.CallSign === null ? '\u2603' : obj.CallSign) + '\u2618' + (obj.IMO === null ? NaN : obj.IMO) + '\u2618' + (obj.MMSID === null ? NaN : obj.MMSID);
    }

    static update(obj : LloydServiceSearch, data : LloydServiceSearchOptions) {
        S.freeze(() => {
            if (data.CallSign !== undefined) obj.CallSign(data.CallSign);
            if (data.IMO !== undefined) obj.IMO(data.IMO);
            if (data.MMSID !== undefined) obj.MMSID(data.MMSID);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/LloydServiceSearch.ts